module.exports = __webpack_public_path__ + "media/src/assets/Images/Room-20f574a41a3684086584d2e2e3ce6d9b.svg";